import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetLeadManuallyStartedEmailSequences as GetLeadManuallyStartedEmailSequencesQuery,
    GetLeadManuallyStartedEmailSequences_lead_queuedEmails as QueuedEmails,
    GetLeadManuallyStartedEmailSequencesVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_MANUALLY_STARTED_EMAIL_SEQUENCES from '../queries/get-lead-manually-started-email-sequences.graphql';

export const useGetLeadManuallyStartedEmailSequences = (
    leadId: string
): {
    queuedEmails: QueuedEmails[] | null | undefined;
    isLoading: boolean;
    isFirstLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetLeadManuallyStartedEmailSequencesQuery,
        GetLeadManuallyStartedEmailSequencesVariables
    >(GET_LEAD_MANUALLY_STARTED_EMAIL_SEQUENCES, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        queuedEmails: data && data.lead && data.lead.queuedEmails,
        isLoading: loading,
        isFirstLoading: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
